import { useAuthStore } from "@/store/useAuthStore";
import { joinCircle } from "@/utils/api";

export const acceptPendingCircleInvite = async () => {
  const {
    pendingCircleInviteOwnerUserId,
    clearPendingCircleInviteOwnerUserId,
  } = useAuthStore.getState();

  if (!pendingCircleInviteOwnerUserId) {
    return { joined: false };
  }

  const response = await joinCircle({
    ownerUserId: pendingCircleInviteOwnerUserId,
  });

  if (response?.success) {
    clearPendingCircleInviteOwnerUserId();
  }

  return {
    joined: Boolean(response?.success),
    message: response?.message,
    data: response?.data,
  };
};
